<template>
    <div id="ObservacoesText">
        <textarea
            ref="observacoesTarefa"
            :value="value"
            @input="updateObservacoes($event.target.value)"
            id="observacoes"
            :maxlength="max"
            class="materialize-textarea"></textarea>
        <label for="observacoes">{{ label }}</label>
    </div>
</template>

<script>
    import Message from '@/helpers/message';
    export default {
        data: () => ({
            label: "Observações",
            max: 300
        }),
        props: ['value'],
        methods: {
            updateObservacoes(text) {
                this.$emit('input', text)
            }
        },
        mounted() {
            $(this.$refs.observacoesTarefa).trigger('autoresize');
        },
        watch: {
            'value'(){
                if(this.value.length >= this.max){
                    Message.messageError('Observação muito grande! Salve e escreva nos comentários!');
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/lead/form/ObservacoesText.vue